
import dayjs, { Dayjs } from "dayjs";

const projectId: string | null = localStorage.getItem('projectId');

export const initialValuesAddendaJobScope = {
    addendaId: projectId,
    addendaJobScopeResults: [
        {
            addendaId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            name: "",
            surveyResult: "",
            fieldType: "",
            sectionId: 0,
            subSectionId: 0,
            lst_AddendaJobScopeActions: {
                id: 0,
                value: ""
            },
            lst_CreatedBy: {
                id: 0,
                value: ""
            },
            lst_ModifiedBy: {
                id: 0,
                value: ""
            },
            createdDT: "2024-12-16T13:52:15.876Z",
            modifiedDT: "2024-12-16T13:52:15.876Z"
        }
    ]
}

export const initialValuesAddenda = {
    id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    projectId: projectId,
    addendaNbr: "",
    addendaType: {
        id: 0,
        value: ""
    },
    addendaDate: dayjs(),
    writtenBy: {
        id: 0,
        value: ""
    },
    comment:'',
    contract: false,
    timeline: false,
    status: "",
    desc: "",
    previousStatus: "",
    internalDesc: "",
    timelineSelection: {
        id: 0,
        value: ""
    },
    saleAmount: "",
    comments:[],
    costAmount:"",
    addendaMarkUp: "",
    amtPayableAcceptance: "",
    isContractLanguage: false,
    isTimeLine: false,
    internalDurationTimeLine: 0,
    externalDurationTimeLine: 0,
    timeLineIsFieldProduction: false,
    timeLineIsProjDevelopment: false,
    projectPaymentReceivableList:{},
    timeLineSel: {
        id: 0,
        value: ""
    },
    addendaStatus: {
        id: 1,
        value: "Pending"
    },
    lst_SubstantialComplete: {
        id: 1,
        value: "Substantial Complete"
    },
    lst_ContractReview: {
        id: 1,
        value: "Contract Review"
    }
}